import { render, staticRenderFns } from "./viewImage.vue?vue&type=template&id=b445d5ee&"
import script from "./viewImage.vue?vue&type=script&lang=js&"
export * from "./viewImage.vue?vue&type=script&lang=js&"
import style0 from "./viewImage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports